import { string, array, bool, func, node } from 'prop-types';
import SelectBox from '@adsk/alloy-select-box';
import { CommonFormField } from '../../../../../components';

const DropDown = ({
  label,
  disabled = false,
  placeholder = label,
  clearable = true,
  multi = true,
  searchable = false,
  ...restProps
}) => (
  <CommonFormField label={label}>
    <SelectBox
      disabled={disabled}
      placeholder={placeholder}
      clearable={clearable}
      multiple={multi}
      searchable={searchable}
      {...restProps}
    />
  </CommonFormField>
);

export const DropDownPropTypes = {
  label: string.isRequired,
  loading: bool,
  selectedOptions: array,
  options: array.isRequired,
  disabled: bool,
  searchable: bool,
  clearable: bool,
  multi: bool,
  optionRenderer: func,
  onChange: func.isRequired,
  placeholder: string,
  labelKey: string,
  valueKey: string,
  subtextGetter: func,
  selectClassName: string,
  searchIcon: node,
  searchPlaceholder: string,
};

DropDown.propTypes = DropDownPropTypes;
DropDown.defaultProps = {
  loading: false,
  optionRenderer: undefined,
  searchable: false,
  disabled: false,
  placeholder: undefined,
  clearable: true,
  multi: true,
  labelKey: undefined,
  valueKey: undefined,
  subtextGetter: undefined,
  selectClassName: undefined,
  searchIcon: undefined,
  searchPlaceholder: undefined,
  selectedOptions: undefined,
};
export default DropDown;
